import { render, staticRenderFns } from "./domainExpiryIncidents.vue?vue&type=template&id=0a05d387&scoped=true"
import script from "./domainExpiryIncidents.vue?vue&type=script&lang=js"
export * from "./domainExpiryIncidents.vue?vue&type=script&lang=js"
import style0 from "./domainExpiryIncidents.vue?vue&type=style&index=0&id=0a05d387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05d387",
  null
  
)

export default component.exports